// extracted by mini-css-extract-plugin
export default {"heading":"FlooringTypesMenu_heading__7qdZ-","flooringTypesMenu":"FlooringTypesMenu_flooringTypesMenu__Ky3bu"};